// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.card[data-v-6fcddd0d] {\n  width: 100%;\n  height: 100%;\n}\n[data-v-6fcddd0d] textarea {\n  line-height: 20px;\n  font-size: 0.8rem;\n  margin-top: 3px !important;\n  margin-right: 2px;\n  margin-bottom: 3px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
